module.exports = __webpack_public_path__ + "static/media/599.767.8b40871d.pdf";